import ApolloClient from 'apollo-client';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import getGraphQLFragmentMatcher from './fragmentMatcher';

const DEFAULT_LINK_OPTIONS = {
  credentials: 'include',
  batchInterval: 30
};

export default function createGraphQLClient(
  graphUri,
  { hydration, linkOptions, appName, appVersion }
) {
  const cache = new InMemoryCache({
    fragmentMatcher: getGraphQLFragmentMatcher()
  }).restore(hydration);

  const linkOpts = { ...DEFAULT_LINK_OPTIONS, ...linkOptions, uri: graphUri };
  const link = new BatchHttpLink(linkOpts);

  const clientOpts = {
    shouldBatch: true,
    connectToDevTools: true,
    cache,
    link,
    name: appName,
    version: appVersion
  };

  return new ApolloClient(clientOpts);
}
